import { CatalogColumn, DateRangeFilterValue, FilterValue, CatalogFilterOption, FilterOptionValue } from './types'

export type FilterInputType = 'TEXT' | 'SELECT' | 'DATE_RANGE'

export const isSyncStatusColumnField = (field?: string) =>
  field === 'sync_status' || Boolean(field?.endsWith('_sync_status'))

const getFilterOptionValue = (option: FilterOptionValue | CatalogFilterOption): FilterOptionValue =>
  typeof option === 'object' && option !== null && 'value' in option ? option.value : option

export const augmentSyncStatusFilterOptions = (
  field: string,
  filterOptions: Array<FilterOptionValue | CatalogFilterOption> = []
): Array<FilterOptionValue | CatalogFilterOption> => {
  if (!isSyncStatusColumnField(field)) return filterOptions

  const options = [...filterOptions]
  const hasDelisted = options.some(
    (option) => String(getFilterOptionValue(option)).trim().toUpperCase() === 'DELISTED'
  )

  if (!hasDelisted) {
    options.push({ label: 'Delisted', value: 'DELISTED' })
  }

  return options
}

export const normalizeFilterInputType = (
  advance?: { filter_input_type?: string },
  field?: string
): FilterInputType => {
  const raw = String(advance?.filter_input_type || '')
    .trim()
    .toUpperCase()
  if (raw === 'SELECT') return 'SELECT'
  if (raw === 'DATE_RANGE') return 'DATE_RANGE'
  if (field === 'created_at' || field === 'updated_at') return 'DATE_RANGE'
  return 'TEXT'
}

export const resolveColumnFilterInputType = (column: CatalogColumn): FilterInputType => {
  if (column.filterInputType === 'SELECT' || column.filterInputType === 'DATE_RANGE') {
    return column.filterInputType
  }
  return normalizeFilterInputType(column.advance_option, column.field)
}

export const isDateRangeColumn = (column: CatalogColumn) =>
  resolveColumnFilterInputType(column) === 'DATE_RANGE'

export const isDateRangeFilterValue = (value: unknown): value is DateRangeFilterValue =>
  typeof value === 'object' && value !== null && ('from' in value || 'to' in value)

export const hasActiveFilterValue = (value: FilterValue | '' | undefined | null) => {
  if (value === '' || value === null || value === undefined) return false
  if (isDateRangeFilterValue(value)) return Boolean(value.from || value.to)
  return true
}

export const isDateRangeColumnFilterable = (column: CatalogColumn) =>
  isDateRangeColumn(column) || column.field === 'created_at' || column.field === 'updated_at'
